import React, { useEffect } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import System from "../../../helper/system";
import { HomePageContentTabs } from '../HomePageContentTabs';

let c = System.getParams();

const ProductTabContent = () => {
    const [{ allTabsCount }, {}] = useHomePageContentStore();

    return (
        <>
            <div className="filter-records">
                <span>Showing {allTabsCount.allContentCount} content results for <b>"{c.search}"</b></span></div>
            <div className="container-fluid maxw100">
                <HomePageContentTabs />
            </div>
        </>
    )
}

export default ProductTabContent